import { getCookie } from './getCookie';

export const getGaUserPseudoIdFromCookie = (gaCookie: string) => {
  return gaCookie.split('.').slice(2).join('.');
};

export const getGaCookie = () => {
  const ga = getCookie('_ga');
  let gaUserPseudoId;

  if (ga) {
    gaUserPseudoId = getGaUserPseudoIdFromCookie(ga);
  }

  return { ga, gaUserPseudoId };
};
